import React from 'react';
import { useNavigation } from '../hooks/useNavigation';
import classnames from 'classnames';
import { getUploadedImagePath } from '@nutastic/nutastic-react-app';

const RelatedContentCard = ({ image, title, subtitle, useWideImage, url }) => {
    const componentClass = 'relatedCard';
    const { loadPage } = useNavigation();
    const classes = classnames(componentClass, {
        [`${componentClass}--useWideImage`]: useWideImage
    });

    const onCardClick = () => {
        if(url) loadPage(url);
    };

    return <div className={classes} onClick={onCardClick}>
        <img src={image} alt={title} />
        <div>
            <h5>{title}</h5>
            { subtitle && <p>{subtitle}</p> }
        </div>
    </div>
};

const RelatedContentTab = ({ artists, music, videos }) => {
    return <div>
        { (Array.isArray(music) && music.length > 0) && <div className="relatedContent">
            <h5>Related Music</h5>
            <div>{ getRelatedMusic(music) }</div>
        </div> }
        { (Array.isArray(videos) && videos.length > 0) && <div className="relatedContent">
            <h5>Related Videos</h5>
            <div>{ getRelatedVideos(videos) }</div>
        </div> }
        { (Array.isArray(artists) && artists.length > 0) && <div className="relatedContent">
            <h5>Related Artists</h5>
            <div>{ getRelatedArtist(artists) }</div>
        </div> }
    </div>
};

const getRelatedMusic = (relatedMusic) => (relatedMusic || []).map(rel => {
    const { image, slug, type, title } = rel;
    return <RelatedContentCard
        image={getUploadedImagePath(image)}
        title={title}
        subtitle={type.toUpperCase()}
        url={`/content/music/${slug}`}
    />
});

const getRelatedVideos = (relatedVideos) => (relatedVideos || []).map(rel => {
    const { image, slug, title } = rel;
    return <RelatedContentCard
        image={getUploadedImagePath(image)}
        title={title}
        url={`/content/video/${slug}`}
        useWideImage={true}
    />
});

const getRelatedArtist = (relatedArtists) => (relatedArtists || []).map(rel => {
    const { image, slug, name } = rel;
    return <RelatedContentCard
        image={getUploadedImagePath(image)}
        title={name}
        useWideImage={true}
        url={`/content/artist/${slug}`}
    />
});


export {
    RelatedContentCard,
    RelatedContentTab,
    getRelatedArtist,
    getRelatedMusic,
    getRelatedVideos
}
